import * as types from './types';
import { LetterStringTypesEnum } from '../../helpers/LetterTypeEnum';
import _ from 'lodash';

const INITIAL_STATE = {
  letters: null,
  loading: false,
  loadError: null,
  badEmails: [],
  badNotificationEmailsHistIds: [],
  badDCEmailsHistIds: [],
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOADING:
      return { ...state, loading: payload };
    case types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOAD_ERROR:
      return {
        ...state,
        loadError: {
          Title: 'Error',
          Message: payload
            ? payload
            : 'An error has occurred. Please try again',
        },
      };

    case types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_GET_BAD_EMAILS:
      var badEmails = payload.map(function(item) {
        return {
          EmailId: item.EmailId,
          EmailLetter: item.EmailLetter,
          LetterType: item.LetterType,
        };
      });

      badEmails = _.uniqBy(badEmails, 'EmailLetter').map(function(u) {
        return {
          EmailId: u.EmailId,
          LetterType: u.LetterType,
          HistoryIds: _.filter(payload, {
            EmailId: u.EmailId,
            EmailLetter: u.EmailLetter,
            LetterType: u.LetterType,
          }).map(m => m.Id),
        };
      });

      var nLetterHistoryIds = payload
        .filter(f => f.LetterType === LetterStringTypesEnum.Notification)
        .map(m => m.Id);
      var dLetterHistoryIds = payload
        .filter(f => f.LetterType === LetterStringTypesEnum.DirectCertification)
        .map(m => m.Id);

      return {
        ...state,
        badEmails: badEmails,
        badNotificationEmailsHistIds: nLetterHistoryIds,
        badDCEmailsHistIds: dLetterHistoryIds,
      };

    case types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_EMAILS_N:
      return {
        ...state,
        badNotificationEmailsHistIds: payload,
      };
    case types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_EMAILS_D:
      return {
        ...state,
        badDCEmailsHistIds: payload,
      };
    case types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_GET_LETTERS:
      return {
        ...state,
        letters: payload,
      };
    case types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_ERRORS:
      return {
        ...state,
        loadError: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/notificationanddirectcertifiedletters/state/letter/reducer.js